
export default {
  // 导航栏
  navbar: {
    title: '自动化管理系统',
    languageSwitch: '语言切换',
    theme: '主题'
  },
  home: {
    welcome: '欢迎进入',
    chargingPlatform: '蔚动力智慧充电运营管理平台',
    currentLanguage: '当前语言',
    currentCompany: '当前公司',
    changePassword: '修改密码',
    logOut: '退出登录'
  },
  commonly: {
    yes: '是',
    not: '否',
    inputContent: '请输入内容',
    element: '元',
    determine: '确 定',
    cancel: '取 消',
    noData: '暂无数据'
  },
  elTable: {
    serialNumber: '序号',
    userAccount: '用户账号',
    userInformation: '用户信息',
    userName: '用户姓名',
    carNumber: '车牌号',
    phoneNumber: '手机号',
    state: '状态',
    oneNoOvercharge: '一号多充',
    operation: '操作'
  },
  enterpriseUser: {
    setThreshold: '设置阈值',
    carInformation: '车辆信息',
    carNumber: '车牌号',
    allPeople: '所有人',
    carType: '车辆类型',
    brandModel: '品牌型号',
    carCode: '车辆识别代码'
  },
  route: {
    userManagement: '用户管理',
    enterpriseUsers: '企业用户',
    editEnterpriseUsers: '企业用户+修改',
    addEnterpriseUsers: '企业用户+新增',
    userDetails: '企业用户+详情',
    userDetails2:'非企业用户+详情',
    UserWallet: '企业用户+用户钱包',
    UserWallet2: '非企业用户+用户钱包',
    isenterpriseUser: '非企业用户',
    addIsenterpriseUser: '非企业用户+新增',
    editIsenterpriseUser: '非企业用户+修改',
    isenterpriseUserDetails: '非企业用户详情',
    administrators: '管理员用户',
    addAdministrators: '管理员用户+新增',
    editAdministrators: '管理员用户+修改',
    roleManagement: '角色管理',
    addRole: '角色管理+新增',
    editRole: '角色管理+修改',
    systemManagement: '系统管理',
    electricEquipmentManagement: '电桩设备管理',
    powerStationManagement: '电站管理',
    addPowerStation: '电站管理+新增',
    editPowerStation: '电站管理+修改',
    powerStationDetails: '电站管理+详情',
    plantRobot: '周边设备',
    electricPileManagement: '电桩管理',
    addElectricPile: '电桩管理+新增',
    editChargingGun: '电桩管理+修改充电枪',
    chargingGunDetails: '电桩管理+充电枪详情',
    interconnectedPowerStation: '互联互通电站',
    InterConStationDetail:"互联互通电站+电站详情",
    whiteList: '白名单',
    addWhiteList: '白名单+新增',
    editWhiteList: '白名单+修改',
    whiteListDetails: '白名单+详情',
    valueAddedServices: '增值服务',
    flowScheme: '流量方案',
    addFlowScheme: '流量方案+新增',
    flowSchemeDetails: '流量方案+详情',
    flowSchemeEdit: '流量方案+修改',
    entranceScheme: '入口方案',
    addEntranceScheme: '入口方案+新增',
    entranceSchemeDetails: '入口方案+详情',
    entranceSchemeEdit: '入口方案+修改',
    operatorManagement: '企业管理',
    addOperatormanagement:'企业管理+新增',
    modifyOperatormanagement:'企业管理+修改',
    operatorWallet: '企业钱包',
    newlyAdded: '互联互通密钥+新增',
    secretKeydetails: '互联互通密钥+详情',
    modify: '修改',
    details: '详情',
    orderManagement: '订单管理',
    userRealTimeOrder: '用户实时订单',
    realTimeOrderDetails: '用户实时订单+详情',
    orderStationManagement: '电站实时订单',
    orderStationmanagementDetail:'电站实时订单+详情',
    userHistoryOrder: '用户历史订单',
    historyOrderDetails: '用户历史订单+详情',
    stationHistoryOrder: '电站历史订单',
    historyStationDetail:'电站历史订单+详情',
    pendingOrders: '待处理订单',
    daichulidingdanchuli:'待处理订单+处理',
    handle: '处理',
    alarmCenter: '告警中心',
    pileSafetyAlarm: '电桩安全告警',
    pileSafetyAlarmDetails: '电桩安全告警+电桩充电告警详情',
    pileOfflineAlarmDetails: '电桩安全告警+电桩离线告警详情',
    pileFaultAlarmDetails: '电桩安全告警+电桩故障告警详情',
    vehicleAlarm: '车辆告警',
    vehicleAlarmDetails: '车辆告警+详情',
    negativeValueAlarm: '账户负值告警',
    stationAlarmSetting: '告警设置',
    addAlarmSetting: '告警设置+新增',
    editAlarmSetting: '告警设置+修改',
    alarmSettingDetails: '告警设置+详情',
    groupManagement: '告警通知组管理',
    addGroupManagement:'告警通知组管理+新增',
    reviseGroup:'告警通知组管理+修改',
    groupManagementDetail:'告警通知组管理+详情',
    alarmRecord: '告警通知记录',
    statisticalCenter: '统计中心',
    stationTotal: '电站统计',
    pileTotal: '终端统计',
    organTotal: '车辆机构统计',
    userTotal: '用户统计',
    timeUserTotal: '用户时期统计',
    timeStationTotal: '运营商时期统计',
    notificationManagement: '通知管理',
    messageSending: '消息发送',
    addInformManagement:'消息发送+新增',
    informDetail:"消息发送+详情",
    reviseInform:'消息发送+修改',
    smsSettings: '短信设置',
    advertisingManagement: '广告管理',
    addAd:'广告管理+新增',
    reviseAd:'广告管理+修改',
    powerStationActivities: '电站活动',
    coupon: '优惠券',
    couponManagerAdd:'优惠券+新增',
    couponDetail:'优惠券+详情',
    preferentialScheme: '优惠方案',
    couponManagement: '优惠券管理',
    taskDetails: '任务详情',
    manualRelease: '手动发放记录',
    ManualReleaseUpdate:'手动发放记录+修改',
    ManualReleaseDetail:'手动发放记录+详情',
    couponIssuance: '优惠券+优惠券发放',
    labelManagement: '标签管理',
    addTag: '新增标签',
    modifyUserTag: '标签管理+修改',
    modifySystemTag: '修改系统标签',
    addPreferentialScheme: '优惠方案+新增',
    preferentialSchemeDetails: '优惠方案+详情',
    editPreferentialScheme: '优惠方案+修改',
    financialManagement: '财务管理',
    financialOverview: '财务概况',
    moneyCount: '分润汇总',
    earnMoney: '分润金额查看',
    profitRecord: '分润记录',
    profitSettle: '分润记录结算',
    moneyDetail: '分润汇总+分润明细',
    payDetail: '分润金额查看+订单明细',
    financialDetails: '财务概况+财务明细',
    orderDetail: '分润金额查看+订单详情',
    ticketManagement: '票务管理',
    ticketManagement: '票务管理',
    ticketEdit: '票务管理+修改',
    invoicingApproval: '开票审批',
    invoicingDetails: '开票审批+详情',
    siteComment: '站点评论',
    chargingCardManagement: '充电卡管理',
    chargingCardEdit: '充电卡管理+修改',
    systemSettings: '系统设置',
    gateManagement: '道闸管理',
    gateDetail:'道闸管理+详情',
    daozhaadd:"道闸管理+新增",
    reviseGate:'道闸管理+修改',
    logView: '日志查看',
    logManagement: '电桩报文',
    logDetail: '报文详情',
    logOperation: '操作日志',
    interconnectionKey: '互联互通密钥',
    appManagement: 'APP版本管理',
    userActivity: '用户活动',
    registrationActivities: '注册活动',
    registrationAdd: '注册活动+新增',
    registrationModify:'注册活动+修改',
    rechargeActivities: '充值活动',
    rechargeAdd: '充值活动+新增',
    rechargeModify:'充值活动+修改',
    rechargeDetail:'充值活动+详情',
    singleConsumption: '单次消费活动',
    singleDetail: '单次消费活动+详情',
    singleAdd: '单次消费活动+新增',
    singleModify:'单次消费活动+修改',
    firstCharge: '首次充电活动',
    firstAdd: '首次充电活动+新增',
    firstDetail: '首次充电活动+详情',
    firstModify:'首次充电活动+修改',
    groupCharge: '组团充电活动',
    groupDetail:'组团充电活动+详情',
    groupModify:'组团充电活动+修改',
    groupAdd: '组团充电活动+新增',
    scanGet: '扫码领券活动',
    scanModify: '扫码领券活动+修改',
    scanAdd: '扫码领券活动+新增',
    scanDetail:'扫码领券活动+详情',
    cumulativeConsumption: '累计消费活动',
    cumulativeAdd: '累计消费活动+新增',
    cumulativeDetail:'累计消费活动+详情',
    cumulativeModify:'累计消费活动+修改',
    shareActivity: '分享活动',
    shareAdd: '分享活动+新增',
    shareModify:'分享活动+修改',
    shareDetail: '分享活动+详情',
    pileUse: '电桩使用统计',
    couponIssuanceDetails: '优惠券+优惠券发放明细',
    pileFault: '电桩故障统计',
    pileFaultList: '电桩品牌列表',
    stationBrand: '电桩品牌管理',
    stationModel: '电桩型号管理',
    stationModelAdd:'电桩型号管理+新增',
    stationModelModify:'电桩型号管理+修改',
    monitorView: '监控查看',
    authorityManagement: '权限管理',
    stationManagement: '场站设备管理',
    interProgramme: '互联方案',
    equityManagement: '权益管理',
    userLevel: '用户等级',
    addUserLevel: '用户等级+新增',
    userEquity: '用户权益',
    addUserEquity: '用户权益+新增',
    reviseUserEquity: '用户权益+修改',
    occupyDetail: '占用详情',
    firmwareVersion: '固件版本管理',
    versionAdd: '固件版本管理+新增',
    versionModify: '固件版本管理+修改',
    nearRobot: '周边设备管理',
    nearAdd: '新增周边设备',
    nearModify: '修改周边设备',
    subsidyManagement: '补贴管理',
    addSubsidy: '补贴管理+新增',
    modifySubsidy: '补贴管理+修改',
    detailSubsidy: '补贴管理+详情',
    keshidaRecord: '科士达告警'
  },
  profitConfig: {
    title: '场站分润设置',
    selectStation: '选择场站',
    searchStationPlaceholder: '请输入场站名称',
    currentStationName: '当前场站',
    notSelected: '未选择',
    profitMode: '分润模式',
    profitModePercent: '按比例分润',
    profitModeFixed: '按固定金额分润',
    percentTip: '比例模式下，各分润方比例之和为 100% 时表示全额分润',
    profitTarget: '分润方',
    selectProfitTarget: '请选择分润方',
    profitShare: '分润比例/金额',
    profitSharePercent: '分润比例(%)',
    profitShareFixed: '分润金额(元/度)',
    percentPlaceholder: '请输入分润比例',
    fixedPlaceholder: '请输入固定分润金额',
    operation: '操作',
    remove: '移除',
    addProfitTarget: '添加分润方',
    reset: '重置',
    save: '保存',
    cancel: '取消',
    search: '查询',
    index: '序号',
    stationName: '场站名称',
    belongOperator: '归属运营商',
    notConfigured: '未配置',
    configProfit: '配置分润',
    configProfitTitle: '配置分润',
    operator: '运营商',
    pleaseSelectStation: '请先选择场站',
    pleaseSelectStationTip: '请先选择场站',
    repeatTargetTip: '该分润方已添加，请勿重复',
    shareErrorTip: '分润比例/金额必须为不小于 0 的数字',
    percentErrorTip: '比例模式下分润比例不能超过 100%',
    saveSuccess: '分润配置保存成功'
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/zh.js